export const idTemporada = "20"; // Puedes cambiarlo manualmente cuando lo necesites

const API_HOST_URL =
  process.env.REACT_APP_API_URL ||
  "https://socceranalyticsapi-aeach7fbenhgcbdj.westeurope-01.azurewebsites.net";

const normalizedApiHostUrl = API_HOST_URL.replace(/\/$/, "").replace(/\/api(?:\/v1)?$/, "");

export const API_BASE_URL = `${normalizedApiHostUrl}/api/v1`;
